import { SellerAddress } from './SellerInfo';

export const COMPANY_DIRECTORY_SOURCE = {
  FRENCH_COMPANY_REGISTRY: 'FrenchCompanyRegistry',
  COMPANIES_HOUSE: 'CompaniesHouse',
  BELGIAN_CROSSROADS_BANK: 'BelgianCrossroadsBank',
  GLEIF: 'Gleif',
} as const;

export type CompanyDirectorySource =
  (typeof COMPANY_DIRECTORY_SOURCE)[keyof typeof COMPANY_DIRECTORY_SOURCE];

export interface CompanyFacts {
  activityCode?: string;
  activitySector?: string;
  employeeRange?: string;
  companySize?: string;
}

export interface CompanySuggestion {
  name: string;
  registrationNumber: string;
  source: CompanyDirectorySource;
  isActive: boolean;
  address?: SellerAddress;
  facts?: CompanyFacts;
}

export const BUSINESS_ACTIVITY = {
  UNKNOWN: 'Unknown',
  RETAILER: 'Retailer',
  E_COMMERCE: 'ECommerce',
  REPAIRER: 'Repairer',
  MANUFACTURER: 'Manufacturer',
  INDUSTRIAL: 'Industrial',
  WHOLESALER: 'Wholesaler',
} as const;

export type BusinessActivity =
  (typeof BUSINESS_ACTIVITY)[keyof typeof BUSINESS_ACTIVITY];

export const BUSINESS_DOMAIN = {
  UNKNOWN: 'Unknown',
  HIGH_TECH: 'HighTech',
  HOME_APPLIANCES: 'HomeAppliances',
  DO_IT_YOURSELF: 'DoItYourself',
  SPORT: 'Sport',
  MOBILITY: 'Mobility',
  FURNITURE: 'Furniture',
  BEAUTY: 'Beauty',
  FASHION: 'Fashion',
  JEWELLERY: 'Jewellery',
  CHILDCARE: 'Childcare',
  TOYS_AND_CRAFTS: 'ToysAndCrafts',
  OTHER: 'Other',
} as const;

export type BusinessDomain =
  (typeof BUSINESS_DOMAIN)[keyof typeof BUSINESS_DOMAIN];

export const AFTER_SALES_VOLUME_RANGE = {
  UNKNOWN: 'Unknown',
  UP_TO_1000: 'UpTo1000',
  FROM_1000_TO_5000: 'From1000To5000',
  FROM_5000_TO_10000: 'From5000To10000',
  FROM_10000_TO_100000: 'From10000To100000',
  ABOVE_100000: 'Above100000',
} as const;

export type AfterSalesVolumeRange =
  (typeof AFTER_SALES_VOLUME_RANGE)[keyof typeof AFTER_SALES_VOLUME_RANGE];

export const CUSTOMER_KIND = {
  UNKNOWN: 'Unknown',
  BUSINESS: 'Business',
  CONSUMER: 'Consumer',
  BOTH: 'Both',
} as const;

export type CustomerKind = (typeof CUSTOMER_KIND)[keyof typeof CUSTOMER_KIND];

export const SUGGESTION_CONFIDENCE = {
  UNKNOWN: 'Unknown',
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
} as const;

export type SuggestionConfidence =
  (typeof SUGGESTION_CONFIDENCE)[keyof typeof SUGGESTION_CONFIDENCE];

export interface CompanyProfileSuggestion {
  activity: BusinessActivity;
  domains: BusinessDomain[];
  afterSalesVolume: AfterSalesVolumeRange;
  customers: CustomerKind;
  confidence: SuggestionConfidence;
  summary?: string;
}
